import React from 'react';
import {Box, Grid, Typography} from '@mui/material';
import {ToastContainer, ToastPosition, toast} from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import {themeColors} from '../../theme/Theme';

interface ToastProps {
  message: string;
}

export function Toast({message}: ToastProps) {
  return (
    <Box>
      <Grid container>
        <Grid item xs={12}>
          <Typography variant="body1">{message}</Typography>
        </Grid>
      </Grid>
    </Box>
  );
}

export function ToastOutput() {
  return (
    <Box
      sx={{
        '& .Toastify__toast-container': {
          zIndex: 1200,
          top: 50,
          width: '100%',
          margin: 0,
        },
        '& .app-toast': {
          position: 'relative',
          paddingLeft: '10px',
          border: `1px solid ${themeColors.backgroundDark}`,
          boxShadow: `0 0 8px 0 ${themeColors.backgroundDark}`,
          margin: '6px 12px',
          opacity: 0.9,
          backgroundColor: themeColors.backgroundNotification,
          color: themeColors.tan,
          borderRadius: 0,
          minWidth: {
            md: 'calc(30% - 24px)',
            lg: 'calc(20% - 24px)',
          },
          maxWidth: {
            md: 'calc(30% - 24px)',
            lg: 'calc(20% - 24px)',
          },
          '& .Toastify__progress-bar--default': {
            background: themeColors.tan,
          },
        },
      }}
    >
      <ToastContainer />
    </Box>
  );
}

interface SendToastProps {
  autoClose?: number | false;
  delay?: number;
  message: string;
  position?: ToastPosition;
}

export function sendToast({
  autoClose,
  delay = 1000,
  message,
  position = toast.POSITION.TOP_LEFT,
}: SendToastProps) {
  return toast(<Toast message={message} />, {
    autoClose,
    className: 'app-toast',
    delay,
    position,
  });
}
